import RevealText from "@/components/RevealText";
import Reveal from "@/components/Reveal";

// Shared secondary-page proposition header.
export default function PageIntro({ index, eyebrow, titleLines, lead, meta }) {
  return (
    <section className="relative border-b border-ink/12 pt-36 pb-16 md:pt-44 md:pb-24">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex items-center gap-4">
          {index && (
            <span className="font-mono text-xs tracking-[0.24em] text-teal">
              {index}
            </span>
          )}
          <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-ink/45">
            {eyebrow}
          </span>
        </div>

        <RevealText
          as="h1"
          lines={titleLines}
          testId="page-title"
          delay={0.1}
          className="mt-8 max-w-4xl font-serif text-4xl leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl"
        />

        {lead && (
          <Reveal delay={0.35} className="mt-8 max-w-2xl">
            <p className="font-sans text-lg leading-relaxed text-ink/70 md:text-xl">
              {lead}
            </p>
          </Reveal>
        )}

        {meta && (
          <Reveal delay={0.45} className="mt-10 flex flex-wrap gap-x-8 gap-y-3">
            {meta.map((m) => (
              <span key={m} className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink/45">
                {m}
              </span>
            ))}
          </Reveal>
        )}
      </div>
    </section>
  );
}
